import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-primary via-brand-primary to-accent overflow-hidden">
      {/* Background Video Overlay */}
      <div className="absolute inset-0 bg-black/20 z-10"></div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      {/* Emergency Banner */}
      <div className="relative z-20 bg-error text-white py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-3">
            <Icon name="AlertTriangle" size={20} className="animate-pulse" />
            <span className="text-sm font-medium">
              Rechtlicher Notfall? Sofortige Beratung verfügbar - 24/7
            </span>
            <a href="tel:09001000312">
              <Button
                variant="outline"
                size="xs"
                className="bg-white text-error border-white hover:bg-error hover:text-white ml-4">
                Jetzt anrufen
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="text-white space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Shield" size={16} />
                <span className="text-sm font-medium">ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH</span>
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                Rechtsberatung per Telefon
                <span className="block text-conversion-accent">wenn Sie sie am meisten brauchen</span>
              </h1>
              
              <p className="text-xl text-white/90 leading-relaxed max-w-2xl">
                Professionelle Rechtsberatung per Telefon - 24/7 verfügbar. 
                Transparente Preise, sofortige Hilfe, keine Wartezeiten.
              </p>
            </div>

            {/* Dual Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:09001000312">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                  className="bg-conversion-accent hover:bg-cta text-white shadow-elevated cta-button text-lg px-8 py-4 w-full sm:w-auto">
                  09001000312 - 2,99 €/Min
                </Button>
              </a>
              
              <Link to="/contact">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  className="border-white text-white hover:bg-white hover:text-primary text-lg px-8 py-4 w-full sm:w-auto">
                  Termin vereinbaren
                </Button>
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-6 pt-8">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={20} className="text-trust-builder" />
                <span className="text-sm">Anwaltliche Schweigepflicht</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Lock" size={20} className="text-trust-builder" />
                <span className="text-sm">DSGVO-konform</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Scale" size={20} className="text-trust-builder" />
                <span className="text-sm">Zugelassene Rechtsanwälte</span>
              </div>
            </div>
          </div>

          {/* Right Content - Professional Image */}
          <div className="relative">
            <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-elevated">
              <div className="aspect-square rounded-xl overflow-hidden">
                <AppImage
                  src="/assets/images/AdvoCall_modern_office.png"
                  alt="AdvoCall modernes Büro – Junges dynamisches Anwaltsteam arbeitet in einem modernen, hellen und offenen Büro mit AdvoCall Schriftzug auf der Glasscheibe"
                  className="w-full h-full object-cover" />

              </div>
              
              {/* Floating Stats */}
              <div className="absolute -top-4 -right-4 bg-trust-builder text-white rounded-lg p-4 shadow-elevated">
                <div className="text-2xl font-bold">24/7</div>
                <div className="text-xs">Verfügbar</div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-conversion-accent text-white rounded-lg p-4 shadow-elevated">
                <div className="text-2xl font-bold">2,99€</div>
                <div className="text-xs">pro Minute</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <div className="animate-bounce">
          <Icon name="ChevronDown" size={32} className="text-white/60" />
        </div>
      </div>
    </section>);


};

export default HeroSection;